// Pure helpers for PendingRequests page.

export const getEndTime = (startSlot, duration) => {
  const startTime = startSlot.split('-')[0];
  const [hours, minutes] = startTime.split(':').map(Number);
  let endHour = hours + duration;
  if (endHour >= 24) endHour = 0;
  return `${endHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const getCustomerInfo = (booking) => {
  if (booking.guest_name || booking.guest_phone) {
    return {
      name: booking.guest_name || 'Guest',
      email: booking.guest_email || 'N/A',
      phone: booking.guest_phone || 'N/A',
      type: 'Guest',
    };
  }
  const info = booking.customer_info || {};
  if (info.user_name) {
    return {
      name: info.user_name,
      email: info.user_email || 'N/A',
      phone: info.user_phone || 'N/A',
      type: 'Member',
    };
  }
  return { name: 'Unknown', email: 'N/A', phone: 'N/A', type: 'Unknown' };
};
